import { PropsWithChildren } from 'react'

import { PaginationProvider } from '@/utils/pagination/pagination-context.tsx'

export const TrackingLinksModule = ({ children }: PropsWithChildren) => {
  return <PaginationProvider>{children}</PaginationProvider>
}
